import { useSearchParamsUpdater } from '@app/shared/hooks/useSearchParamsUpdater';

type WithPage = { page: number };

export const usePaginationSearchParams = <T extends WithPage>() => {
  const { searchParams, updateSearchParams } = useSearchParamsUpdater<T>();
  const page = Number(searchParams.get('page')) || 1;

  const handleSearchParamsChange = (updates: Partial<T>) => {
    const newUpdates = 'page' in updates ? updates : { ...updates, page: 1 };
    updateSearchParams(newUpdates);
  };

  const setPage = (newPage: number) => {
    handleSearchParamsChange({ page: newPage } as Partial<T>);
  };

  const handlePrevPage = () => {
    setPage(Math.max(page - 1, 1));
  };

  const handleNextPage = (totalPages: number) => {
    setPage(Math.min(page + 1, totalPages));
  };

  return {
    searchParams,
    page,
    setPage,
    handleSearchParamsChange,
    handlePrevPage,
    handleNextPage,
  };
};
